import { type SvgProps, SvgWrapper } from '../utils';

export function ArrowDownIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M11.25 5C11.25 4.58579 11.5858 4.25 12 4.25C12.4142 4.25 12.75 4.58579 12.75 5V17.1895L18.4697 11.4697C18.7626 11.1768 19.2374 11.1768 19.5303 11.4697C19.8232 11.7626 19.8232 12.2374 19.5303 12.5303L12.5303 19.5303C12.2374 19.8232 11.7626 19.8232 11.4697 19.5303L4.46973 12.5303C4.17684 12.2374 4.17684 11.7626 4.46973 11.4697C4.76262 11.1768 5.23738 11.1768 5.53028 11.4697L11.25 17.1895V5Z" />
    </SvgWrapper>
  );
}
